import { render, staticRenderFns } from "./DoeMatchInfo.vue?vue&type=template&id=787080fc&"
import script from "./DoeMatchInfo.vue?vue&type=script&lang=js&"
export * from "./DoeMatchInfo.vue?vue&type=script&lang=js&"
import style0 from "./DoeMatchInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports